module.exports = "/_next/static/images/5251cbec0a1ec41c347ffcadfd3d40dd-card-xs.png.webp";